import { render } from "./guide-page.vue?vue&type=template&id=12609fc6&scoped=true"
import script from "./guide-page.vue?vue&type=script&lang=js"
export * from "./guide-page.vue?vue&type=script&lang=js"

import "./guide-page.vue?vue&type=style&index=0&id=12609fc6&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12609fc6"]])

export default __exports__